import styled from 'styled-components'
import { Carousel } from 'antd'

export const StyledCarousel = styled(Carousel)`
  padding: 50px 0;
  .ant-image,
  .ant-image-img {
    width: 100%;
    cursor: pointer;
    border-radius: 15px;
    object-fit: cover;
  }

  .slick-dots,
  .slick-dots-bottom {
    bottom: -12px;
  }
  .slick-active {
    padding: 0 45px;
  }
  .slick-track {
    margin: 0 auto;
  }
  .slick-dots > li > button {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: var(--grey);
  }
  .slick-dots {
    li {
      width: 12px !important;
    }
    li,
    button {
      width: 12px;
      height: 12px;
      &.slick-active > button,
      li {
        background-color: var(--orange-peel) !important;
      }
    }
  }
  .slick-prev,
  .slick-next {
    display: flex !important;
    align-items: center;
    justify-content: center;
    background-color: var(--orange-peel);
    height: 52px;
    width: 52px;
    border-radius: 50%;
    color: var(--white) !important;
    z-index: 3;
    font-size: 24px;
  }
  .slick-prev {
    left: 70px !important;
  }
  .slick-next {
    right: 70px !important;
  }

  .slick-arrow {
    &.slick-prev:hover,
    &.slick-next:hover,
    &.slick-prev:focus,
    &.slick-next:focus {
      background-color: var(--orange-peel) !important;
    }
  }

  @media only screen and (max-width: 576px) {
    padding: 24px 0;
    .ant-image,
    .ant-image-img {
      max-height: 92px !important;
      width: 320px;
    }
    .slick-slide {
      float: inline-start !important;
      max-height: 220px !important;
      &.slick-active,
      &.slick-center {
        padding: 0 12px !important;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    padding: 24px 0;
    .ant-image,
    .ant-image-img {
      max-height: 202px !important;
      width: 100%;
    }
    .slick-slide {
      &.slick-active,
      &.slick-center {
        padding: 0 24px;
      }
    }
  }
`

export const StyledCarouselItem = styled.div`
  border-radius: 15px;
  background-color: var(--white);
  width: 70% !important;
  height: 364px;
  background-image: url(${(props) => props.bg});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
`
